import React from 'react'
import RedirectTemplate from 'src/components/template/redirect'
export default (props) => (
  <RedirectTemplate location={props.location} destination="https://www.fubo.tv/bienvenido" />
)
